import React, { useEffect, useState } from "react";

import { useAuthGlobal } from "../../../../../../contexts/auth-context/auth-context";

import { FilterModel } from "../../../../../../domain/models/enum";

import CompanyListPage from "../../../../../../presentation/pages/admin/companies/list";

import { settings } from "../../../../../configs/settings";

import toastUtils from "../../../../../../utils/ToastUtils";
import { DeveloperResponseModel } from "../../../../../../domain/models/developer.model";
import { makeRemoteDeveloper } from "../../../../usecases/developer/remote-developer-factory";

const generateFilter = (values: any): string =>
  Object.keys(values)
    .filter((el) => !!values[el])
    .map((el) => {
      if (el === "name") {
        return `${el}~${values[el]}`;
      }
      if (el === "approved") {
        return `${el}=${values[el]}`;
      }
      return el;
    })
    .join(",");

function MakeComapaniesList(): JSX.Element {
  const { profile, user } = useAuthGlobal();
  const [list, setList] = useState<DeveloperResponseModel>();
  const [params, setParams] = useState<FilterModel>({});
  const [loading, setLoading] = useState<boolean>();
  const [reload, setReload] = useState<boolean>(false);

  const exportList = (): Promise<void> =>
    makeRemoteDeveloper().exportCSV({
      filters: generateFilter({
        ...params?.filters,
        approved: true,
      }),
    });

  const handleReload = (): void => {
    setReload((prev) => !prev);
  };

  useEffect(() => {
    const loadData = async (): Promise<void> => {
      try {
        setLoading(true);

        const data = await makeRemoteDeveloper().load({
          size: settings.perPage,
          page: params?.page,
          sort: params?.sort,
          query: params?.query,
          filters: generateFilter({
            ...params?.filters,
            approved: true,
          }),
        });
        setList(data);

        setLoading(false);
      } catch (e) {
        setLoading(false);
        toastUtils.showMessage({
          message: "Erro ao carregar dados",
          type: "error",
        });
      }
    };

    loadData();
  }, [params, profile, user, reload]);

  return (
    <CompanyListPage
      // params={params}
      list={list}
      setParams={setParams}
      loading={loading}
      exportList={exportList}
      handleReload={handleReload}
    />
  );
}

export default MakeComapaniesList;
